// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2LSU0","footer":"ChangeClinic_footer__3NLdu"};